import { render } from "./LogisticsNews.vue?vue&type=template&id=75321d64&scoped=true"
import script from "./LogisticsNews.vue?vue&type=script&lang=js"
export * from "./LogisticsNews.vue?vue&type=script&lang=js"

import "./LogisticsNews.vue?vue&type=style&index=0&id=75321d64&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75321d64"]])

export default __exports__